/* -------------------------------------------------------
 * SEARCH PAGE FILTER LOGIC (Color + Custom)
 * -----------------------------------------------------*/
if (window.location.pathname.startsWith("/search")) {

  const params = new URLSearchParams(window.location.search);
  const q = params.get("q") || "";
  let query = q.trim();

  const activeFilter = sessionStorage.getItem("activeSearchFilter");

  // Simple normalizer
  const normalize = (v) =>
    v.toLowerCase().replace(/&/g, " ").replace(/\s+/g, " ").trim();

  /* ----------------------------
   * Highlight active filter
   * ---------------------------- */
  if (activeFilter) {
    document
      .querySelectorAll(".js-title-color-term, .js-custom-term")
      .forEach((el) => {
        const raw =
          el.getAttribute("data-color") ||
          el.getAttribute("data-filter") ||
          "";
        if (normalize(raw) === activeFilter) {
          el.classList.add(
            "collection-filters__filter-list-item--active"
          );
        }
      });
  }

  /* ----------------------------
   * Hide filters typed by user
   * ---------------------------- */
  const tokens = normalize(q).split(" ");
  const userTokens = activeFilter
    ? tokens.filter((t) => t !== activeFilter)
    : tokens;

  document
    .querySelectorAll(".js-title-color-term, .js-custom-term")
    .forEach((el) => {
      const raw =
        el.getAttribute("data-color") ||
        el.getAttribute("data-filter") ||
        "";
      const val = normalize(raw);

      if (val === activeFilter) return;
      if (userTokens.includes(val)) el.style.display = "none";
    });

  /* ----------------------------
   * Click handler (shared)
   * ---------------------------- */
  document
    .querySelectorAll(
      ".js-title-color-term .collection-filters__filter-link, .js-custom-term"
    )
    .forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        const parent =
          this.closest(".js-title-color-term") ||
          this.closest(".js-custom-term") ||
          this;

        const raw =
          parent.getAttribute("data-color") ||
          parent.getAttribute("data-filter") ||
          "";
        const clicked = normalize(raw);

        // Remove same filter
        if (clicked === activeFilter) {
          query = query.replace(activeFilter, "").trim();
          sessionStorage.removeItem("activeSearchFilter");
        } else {
          // Replace old filter
          if (activeFilter) {
            query = query.replace(activeFilter, "").trim();
          }
          query = `${query} ${clicked}`.trim();
          sessionStorage.setItem("activeSearchFilter", clicked);
        }

        window.location.href = `/search?q=${encodeURIComponent(query).replace(/%20/g, '+')}`;
      });
    });
}
